// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recent-keywords .search-section__content[data-v-7ec384f5]{display:flex;flex-wrap:wrap;gap:8px}.recent-keywords .search-section__content>a[data-v-7ec384f5]{background:#f4f3f8;border-radius:4px;min-width:0;padding:4px 6px}.recent-keywords .search-section__content>a[data-v-7ec384f5]:hover{background:#f2e3eb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
